import { useEffect, useState } from "react";
import { useDataProvider } from "react-admin";
import { FactoryAccessControlProvider } from "./access";
import { MyContextProvider } from "../components/myContext";
import { Loading } from "../../components/customLoading";

export const WithAccessControlProvider = ({ render, children }) => {
  const dataProvider = useDataProvider();
  const [acp, setAcp] = useState(null);

  useEffect(() => {
    FactoryAccessControlProvider(dataProvider).then((acp) => {
      setAcp(acp);
    });
  }, []);

  if (!acp) {
    return <Loading loadingSecondary="Retrieving permissions info" />;
  }

  return (
    <MyContextProvider value={{ acp }}>
      {render ? render(acp) : children}
    </MyContextProvider>
  );
};
